<template>
    <q-dialog
        v-bind="$attrs"
        ref="popup"
        :no-parent-event="true"
        :data-component-name="$options.name"
    >
        <q-card>
            <q-card-section class="row items-center q-pb-none">
                <div class="text-h6">Close icon</div>
                <q-space />
                <q-btn icon="close" flat round dense v-close-popup />
            </q-card-section>

            <q-card-section>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum repellendus sit voluptate voluptas eveniet porro. Rerum blanditiis perferendis totam, ea at omnis vel numquam exercitationem aut, natus minima, porro labore.
            </q-card-section>
        </q-card>
    </q-dialog>
</template>

<script>
    import QDialog from 'quasar'

    export default {
        name: 'CommunicationPopup',
        extends: QDialog,
        props: {
            // value: {
            //     type: Boolean,
            //     default: false
            // },
        },
        mount(){

        },
        computed: {

        },
        methods:{

        }
    }
</script>